import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'td-wb-selectable-input-panel',
  template: '<ng-content />',
  styleUrls: ['selectable-input-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectableInputPanelComponent {
  @HostBinding('class.td-wb-selectable-input-panel') readonly panelClass: boolean = true;
}
